<template lang="html">
  <div class="">
    <table class="table fc-m-cong">
      <!-- table headings -->
      <thead>
        <tr>
          <th scope="col">Name</th>
          <th class="d-none d-sm-table-cell" scope="col">
            State
          </th>
          <th class=" d-none d-lg-table-cell" scope="col">
            Party
          </th>
          <th class="" scope="col">
            {{ activeWeek !== null ? "Points" : "Weekly Average" }}
          </th>
          <th scope="col"></th>
        </tr>
      </thead>
      <!-- loader -->
      <tbody v-if="members === null">
        <tr>
          <td class="bg-light" colspan="5">
            <loader v-bind:embeded="true"></loader>
          </td>
        </tr>
      </tbody>
      <!-- members -->
      <tbody v-else-if="members !== null && members.length > 0">
        <tr v-for="m in members" v-bind:key="m.data.id">
          <!-- name -->
          <td class="p-0 ">
            <div class="d-flex align-items-center">
              <div
                class="fc-m-cong__image"
                :style="{
                  backgroundImage: `url(https://fc-congress-members.s3.us-east-2.amazonaws.com/${
                    m.data.bioguide
                  }.jpeg), url(https://fc-congress-members.s3.us-east-2.amazonaws.com/placeholder_square.jpeg)`
                }"
              ></div>
              <div class="">
                <router-link
                  :to="{ name: ':member', params: { memberId: m.data.id } }"
                  class="fc-m-cong__name"
                >
                  <strong>
                    {{
                      m.data.common_name != ""
                        ? m.data.common_name
                        : m.data.first_name
                    }}
                    {{ m.data.last_name }}
                  </strong>
                </router-link>
                <div v-if="m.data.status === 'inactive' && activeWeek === null">
                  <span class="badge badge-warning">Inactive</span>
                </div>
              </div>
            </div>
          </td>
          <!-- state -->
          <td class=" d-none d-sm-table-cell">
            {{ m.data.state }}
          </td>
          <!-- party -->
          <td class=" d-none d-lg-table-cell">
            <svg
              :title="m.data.party"
              class="fc-a-icon fc-a-icon--size-6"
              :class="'fc-a-icon--' + m.data.party.toLowerCase()"
            >
              <use v-bind:xlink:href="'#icon_' + m.data.party" />
            </svg>
          </td>
          <!-- points -->
          <td v-if="activeWeek !== null">
            <strong>{{ m.data.points === null ? 0 : m.data.points }}</strong>
          </td>
          <td v-else>
            <span class="text-secondary">
              <strong>{{ m.data.running_average }}</strong>
            </span>
          </td>
          <!-- drop button -->
          <td>
            <button
              v-if="showButtons"
              @click="$emit('drop', m.data.id)"
              type="button"
              class="btn btn-primary btn-sm"
            >
              Drop
            </button>
          </td>
        </tr>
      </tbody>
      <!-- no members found message -->
      <tbody v-else-if="members !== null && members.length === 0">
        <tr>
          <td class="bg-light" colspan="5">
            No legislators found.
          </td>
        </tr>
      </tbody>
    </table>
    <!-- add button -->
    <div
      class=""
      v-if="showButtons && members !== null && members.length < limit"
    >
      <router-link
        :to="
          `/leagues/${$route.params.leagueId}/teams/${
            $route.params.teamId
          }/add?chamber=${limit == 4 ? 'Senate' : 'House'}`
        "
        class="btn btn-success btn-sm"
      >
        + Add Legislator
      </router-link>
    </div>
  </div>
</template>

<script>
import Loader from "@/views/components/Loader";

export default {
  name: "TeamCongressList",
  components: {
    loader: Loader
  },
  props: {
    members: { type: Array, default: null },
    activeWeek: { type: Number, default: null },
    showButtons: { type: Boolean, default: true },
    limit: { type: Number, default: 0 }
  }
};
</script>

<style lang="css" scoped></style>
